<template>
    <div class="view-inbound-invoices-page">
        <base-header
            class="warehouse-main-page__header"
            :titulo="translate('messages.inbound_invoices')"
            :voltarPara="true"
            icon="el-icon-upload"
        />
        <div class="view-container-wrapper">
            <div class="content">
                <inbound-invoices-filters @changeFilters="changeFilters" />
                <el-card class="inbound-invoices-card">
                    <div class="inbound-invoices-card__header">
                        <div class="inbound-invoices-card__header-text">
                            <h3>{{ translate('messages.inbound_invoices_list_title') }}</h3>
                            <p>{{ translate('messages.inbound_invoices_list_description') }}</p>
                        </div>
                        <div class="inbound-invoices-card__header-actions">
                            <el-button
                                type="primary"
                                icon="el-icon-download"
                                :disabled="itensSelecionados.length === 0"
                                @click="downloadSolicitudes"
                            >
                                {{ translate('messages.inbound_invoices_download_btn') }}
                            </el-button>
                            <el-button
                                type="primary"
                                icon="el-icon-download"
                                @click="downloadTodosRegistros"
                            >
                                {{ translate('messages.inbound_invoices_download_all_btn') }}
                            </el-button>
                            <el-button
                                type="primary"
                                icon="el-icon-upload2"
                                @click="importResultados"
                            >
                                {{ translate('messages.inbound_invoices_import_btn') }}
                            </el-button>
                        </div>
                    </div>
                    <inbound-invoices-table ref="inboundInvoicesTable" :filters="filters" @selectionChange="onSelectionChange" />
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import InboundInvoicesFilters from '@/modules/warehouse/views/pages/viewInboundInvoices/components/filters/index.vue';
import InboundInvoicesTable from '@/modules/warehouse/views/pages/viewInboundInvoices/components/table/index.vue';
import NotaEntradaService from '@/services/NotaEntradaService';

export default {
    name: 'ViewInboundInvoicesPage',
    components: {
        BaseHeader,
        InboundInvoicesFilters,
        InboundInvoicesTable
    },
    data() {
        return {
            filters: {},
            itensSelecionados: []
        };
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },
        changeFilters(filters) {
            this.filters = filters;
        },
        onSelectionChange(linhas) {
            this.itensSelecionados = linhas;
        },
        downloadSolicitudes() {
            const idsFilaProcessamento = this.itensSelecionados.map(item => item.idFilaProcessamento);

            NotaEntradaService.downloadPlanilhaAnalise(idsFilaProcessamento)
                .then(() => {
                    this.$notify.success({
                        message: this.translate('messages.file_downloaded_successfully')
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.translate('messages.error_downloading_file')
                    });
                });
        },
        downloadTodosRegistros() {
            NotaEntradaService.downloadPlanilhaAnalisePorFiltro(this.filters)
                .then(() => {
                    this.$notify.success({
                        message: this.translate('messages.file_downloaded_successfully')
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.translate('messages.error_downloading_file')
                    });
                });
        },

        importResultados() {
            this.$router.push({ name: 'ImportarResultadosNotasEntrada' });
        }
    }
};
</script>

<style scoped lang="scss">
.view-inbound-invoices-page {
    .view-container-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
    }

    .inbound-invoices-card {
        &__header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 16px;
            gap: 16px;

            @media (max-width: 768px) {
                flex-direction: column;
                align-items: stretch;
            }

            &-text {
                flex: 1;

                h3 {
                    font-size: 16px;
                    font-weight: 600;
                    color: #3b3b3b;
                    margin: 0 0 8px 0;
                }

                p {
                    font-size: 13px;
                    color: #7c7c7c;
                    margin: 0;
                }
            }

            &-actions {
                display: flex;
                gap: 8px;
                flex-shrink: 0;

                @media (max-width: 768px) {
                    flex-direction: column;
                    width: 100%;

                    .el-button {
                        width: 100%;
                        margin: 0;
                    }
                }
            }
        }
    }
}
</style>
